import {
  dropDownItemClass,
  dropDownListClass,
  dropDownMenuClass,
} from './dropDownClasses';

/**
 * DropDownItemType 타입 정의
 * key: 고유 키
 * label: 드롭다운 아이템에 표시될 레이블
 * isActive: 아이템의 활성화 상태 (선택된 상태)
 * onClick: 아이템 클릭 시 호출되는 함수
 * hasError: error 스타일링 사용. 실제 에러는 아님.
 * isDisabled: 아이템의 비활성화 상태
 */
export type DropDownItemType = {
  key: string;
  label: string | number | React.ReactNode;
  isActive?: boolean;
  isDisabled?: boolean;
  hasError?: boolean;
  onClick?: () => void;
};

/**
 * items: 드롭다운에 표시될 아이템들의 배열
 * size: 드롭다운의 크기(sm: 옵션 텍스트 맞춤 너비, md: auto 또는 styleWidthSize로 설정한 너비)
 */
type AlignType = 'left' | 'right';

export type Props = {
  items: DropDownItemType[];
  size?: 'sm' | 'md';
  styleWidthSize?: string;
  align?: AlignType;
};

/**
 * 메뉴 박스의 클래스는 ./dropDownClasses 에 있다. 인하우스 Select 가 같은 문자열을
 * 재사용하므로 룩을 바꿀 때는 그쪽을 고칠 것.
 * mt-1(=4px)은 배치 담당인 이 래퍼가 갖는다(Select 는 위로 열릴 때 mb-1 을 쓴다).
 */
export default function DropDown({
  items,
  size = 'sm',
  styleWidthSize = 'auto',
  align = 'left',
}: Props) {
  const isSmallSize = size === 'sm';

  return (
    <div
      className={`absolute top-full z-10 ${align === 'left' ? 'right-0' : 'left-0'}`}
    >
      <div
        className={`mt-1 ${dropDownMenuClass(isSmallSize)}`}
        style={isSmallSize ? undefined : { width: styleWidthSize }}
      >
        <ul className={dropDownListClass}>
          {items?.map((item) => (
            <li key={item.key}>
              <button
                type="button"
                disabled={item.isDisabled}
                onClick={item.onClick}
                className={dropDownItemClass(isSmallSize, item)}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
